import PageContainer from '../common/PageContainer';

const ActivationContainer = ({ children }) => {
    return (
        <PageContainer>
            {children}
        </PageContainer>
    );
};

export default ActivationContainer;
